import { CategoryListItemType } from "./types";

export enum categories {
	CONFIGURABLE_TEST_SYSTEMS = "Configurable Test Systems",
	PARALLEL_DIGITAL_TEST = "Parallel Digital Test",
	SERIAL_BUS_TEST = "Serial Bus Test",
	OPTICAL_TEST = "Optical Test",
	SWITCHING = "Switching",
	ANALOG_TEST = "Analog Test",
}

export const displayedColumns = {
	"Configurable Test Systems": [
		"Product Name",
		"Product Description",
		"Typical Test Applications",
	],
	"Parallel Digital Test": [
		"Product Name",
		"Product Description",
		"Supported Bus",
		"Capabilities",
	],
	"Serial Bus Test": [
		"Product Name",
		"Product Description",
		"Supported Bus",
		"Typical Test Applications",
	],
	"Optical Test": ["Product Name", "Product Description", "Capabilities"],
	Switching: ["Product Name", "Product Description", "Capabilities"],
	"Analog Test": ["Product Name", "Product Description", "Capabilities"],
};

export const filters = {
	"Configurable Test Systems": [
		{
			name: "Platform",
			options: ["PXI", "PXIe", "LXI", "VXI"],
		},
		{
			name: "Test Applications",
			options: [
				"Depot (D-level) test and repair",
				"Design verification",
				"Field and Operational-level (O-level) test",
				"Flightline test",
				"Intermediate-level (I-level) test and repair",
				"Manufacturing",
				"Multi-site manufacturing and depot",
				"Product troubleshooting",
				"System integration",
			],
		},
	],
	"Parallel Digital Test": [
		{
			name: "Platform",
			options: ["PXI", "PXIe", "LXI", "VXI"],
		},
		{
			name: "Number of Channels",
			options: ["20", "32", "48", "64", "72", "96"],
		},
		{
			name: "SW-Defined",
			options: ["Yes", "No"],
		},
		{
			name: "CE",
			options: ["Yes", "No"],
		},
		{
			name: "Supported Bus",
			options: [
				"LVTTL",
				"TTL",
				"LVDS",
				"M-LVDS",
				"I2C",
				"SPI",
				"PCI",
				"1149.1 Boundary Scan",
				"Multi-Gigabit Transceiver (MGT)",
				"Programmable Digital I/O",
				"Custom parallel bus",
			],
		},
		{
			name: "Test Applications",
			options: [
				"Parallel digital functional test",
				"Boundary scan",
				"FLASH Programming",
				"Custom bus test",
				"Concurrent parallel and serial bus test",
			],
		},
	],
	"Serial Bus Test": [
		{
			name: "Platform",
			options: ["PXI", "PXIe", "LXI", "VXI"],
		},
		{
			name: "Physical Interface",
			options: ["Copper", "Optical"],
		},
		{
			name: "SW-Defined",
			options: ["Yes", "No"],
		},
		{
			name: "CE",
			options: ["Yes", "No"],
		},
		{
			name: "Supported Bus",
			options: [
				"LVTTL",
				"Fibre Channel",
				"sFPDP",
				"PCIe",
				"Aurora",
				"SRIO",
				"Ethernet",
				"Custom bus",
				"LVDS",
				"M-LVDS",
				"Multi-Gigabit Transceiver (MGT)",
				"1149.1 Boundary Scan",
				"AS5643 Mil-FireWire Instrument",
				"ARINC 818",
				"SMPTE 292",
				"RS-232",
				"USB 2.0",
				"USB 3.0",
				"eSATA",
				"I2C",
				"GPIO",
				"RS-485",
				"RS-422",
				"ARINC 708",
				"PRBS",
				"RRBS",
				"HOTLink",
				"IRIG-B",
			],
		},
		{
			name: "Test Applications",
			options: [
				"AESA Radar",
				"Boundary scan",
				"Concurrent parallel and serial bus test",
				"Copper to optical conversion",
				"Custom bus test",
				"FLASH Programming",
				"Data Intensive Testing",
				"Network communications",
//				"Real-time processing of data",
				"Video processing",
			],
		},
	],
	"Optical Test": [
		{
			name: "Platform",
			options: ["PXIe", "LXI"],
		},
		{
			name: "Physical Interface",
			options: ["Copper", "Optical"],
		},
		{
			name: "Number of Channels",
			options: ["4", "8", "16"],
		},
		{
			name: "Test Applications",
			options: [
				"Optical Test",
				"Optical Switching",
				"Copper to optical conversion",
			],
		},
	],
	Switching: [
		{
			name: "Platform",
			options: ["PXI", "PXIe", "LXI", "VXI"],
		},
		{
			name: "Physical Interface",
			options: ["Copper", "Optical"],
		},
		{
			name: "Number of Channels",
			options: ["8", "12", "16", "48", "64"],
		},
		{
			name: "Test Applications",
			options: ["Optical Test", "Optical Switching", "Analog Switching"],
		},
	],
	"Analog Test": [
		{
			name: "Platform",
			options: ["PXI", "PXIe", "LXI", "VXI"],
		},
		{
			name: "Function",
			options: [
				"Digital Sampling Oscilloscope",
				"Digital Multimeter",
				"Arbitrary/Function Waveform Generator",
				"Multifunction Analog Measurements",
				"Digitizer",
				"Limit Detector",
				"Timer/Counter",
			],
		},
		{
			name: "Number of Channels",
			options: ["2", "4"],
		},
		{
			name: "Analog Bandwidth",
			options: ["50 MHz", "300 MHz", "500 MHz", "1 GHz"],
		},
		{
			name: "Maximum Sample Rate",
			options: ["200 MS/s", "800 MS/s", "1 GS/s", "2 GS/s", "4 GS/s"],
		},
		{
			name: "Resolution",
			options: ["8 Bit", "12 Bit", "14 Bit"],
		},
	],
};

declare global {
	interface Window { productFinderFilters: any; }
}

const categoryList: CategoryListItemType[] = Object.values(categories).map(
	(category) => ({
		label: category,
		filters: ( window.productFinderFilters[ category ] || filters[category] ).map((filter: any) => ({
			label: filter.name,
			options: filter.options.map((option: any) => ({
				label: option,
				value:
					option === "Yes" || option === "No"
						? option === "Yes"
							? "true"
							: "false"
						: option,
			})),
		})),
	})
);
export { categoryList };
